module.exports = __webpack_public_path__ + "static/img/2_2_6.0af936b5.jpg";